import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {SelectInput} from 'admin-on-rest';
import {convertDate} from '../shared/functions';
import {TIME_ZONE_OFFSETS} from '../shared/dateTimeLists';
import FormattedDateTextInput from './FormattedDateTextInput';
import {filterStyles} from '../shared/styles-filter';

/**
 * A form containing a SelectInput component with Mode choices
 *
 */
class DateRangeFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayDateFilter: false,
            selectedStartDate: null,
            selectedStartDateObject: null,
            selectedEndDate: null,
            selectedOffset: null,
        };
        this.setEndDateLimit = this.setEndDateLimit.bind(this);
        this.handleStartDateSelect = this.handleStartDateSelect.bind(this);
        this.handleEndDateSelect = this.handleEndDateSelect.bind(this);
        this.handleOffsetSelect = this.handleOffsetSelect.bind(this);
    }

    setEndDateLimit() {
        const {
            selectedStartDateObject
        } = this.state;

        const {
            endMaxDate,
            limitEndRange
        } = this.props;

        if (endMaxDate) {
            // If an End date is set, use it
            return endMaxDate;
        }
        if (limitEndRange) {
            let today = new Date();
            if (limitEndRange === '1-year-after' && selectedStartDateObject) {
                // The End date may be no more than a year after the selected Start date
                let endDate = new Date(selectedStartDateObject.getTime());
                endDate.setMonth(endDate.getMonth() + 12);
                if (endDate.getTime() <= today.getTime()) {
                    return endDate;
                }
            }
        }
        // Otherwise, the End date can be no later than today
        return new Date();
    }

    /* Selection Processing ------------------------------ */

    /**
     * Handle selection event for Start Date
     *
     * @param event
     * @param index
     * @param value
     */
    handleStartDateSelect(event, index, value) {
        if (index && index !== value) {
            // Convert date selection from YYYY-MM-DDT00:00:00.000Z to yyyy-mm-dd
            const dateStr = convertDate(index, 'query', false, true);
            this.setState({
                    selectedStartDate: dateStr,
                    selectedStartDateObject: index,
                    selectedEndDate: null,
                },
                () => {
                    if (typeof this.props.onSelectStartDate === 'function') {
                        this.props.onSelectStartDate('start_date', dateStr);
                    }
                }
            );
        }
    }

    /**
     * Handle selection event for End Date
     *
     * @param event
     * @param index
     * @param value
     */
    handleEndDateSelect(event, index, value) {
        if (index && index !== value) {
            // Convert date selection from YYYY-MM-DDT00:00:00.000Z to yyyy-mm-dd
            const dateStr = convertDate(index, 'query', false, true);
            this.setState({
                    selectedEndDate: dateStr
                },
                () => {
                    if (typeof this.props.onSelectEndDate === 'function') {
                        this.props.onSelectEndDate('end_date', dateStr);
                    }
                }
            );
        }
    }

    /**
     * Handle selection event for Time Zone Offset
     *
     * @param event
     * @param index
     * @param value
     */
    handleOffsetSelect(event, index, value) {
        if (index && index !== value) {
            this.setState({
                    selectedOffset: index
                },
                () => {
                    if (typeof this.props.onSelectOffset === 'function') {
                        this.props.onSelectOffset('offset', index);
                    }
                });
        }
    }

    render() {
        const {
            includeOffset,
            labelEndDate,
            labelOffset,
            labelStartDate,
            startMinDate
        } = this.props;

        const {
            selectedStartDateObject
        } = this.state;

        const today = new Date();
        const endMaxDateObject = this.setEndDateLimit();

        // If the Start date is more than a year back, the End date should display year selection first
        const displayEndYearFirst = (endMaxDateObject && (endMaxDateObject.getTime() < today.getTime()));
        const endValue = (displayEndYearFirst) ? null : endMaxDateObject;

        return (
            <div className="list-filter">
                <FormattedDateTextInput
                    name="start_date"
                    source="start_date"
                    label={labelStartDate}
                    onChangeFunc={this.handleStartDateSelect}
                    minDate={(startMinDate) ? startMinDate : new Date()}
                />
                <FormattedDateTextInput
                    name="end_date"
                    source="end_date"
                    label={labelEndDate}
                    onChangeFunc={this.handleEndDateSelect}
                    minDate={selectedStartDateObject}
                    value={endValue}
                    disabled={!selectedStartDateObject}
                />
                {includeOffset &&
                    <Field name="offset"
                           component={SelectInput}
                           label={labelOffset}
                           choices={TIME_ZONE_OFFSETS}
                           onChange={this.handleOffsetSelect}
                           elStyle={filterStyles.selectInput}
                    />
                }
                <hr style={filterStyles.break}/>
            </div>
        );
    }
}

DateRangeFields.propTypes = {
    endMaxDate: PropTypes.object,
    includeOffset: PropTypes.bool,
    labelEndDate: PropTypes.string,
    labelOffset: PropTypes.string,
    labelStartDate: PropTypes.string,
    limitEndRange: PropTypes.string,
    onSelectField: PropTypes.func,
    onSelectEndDate: PropTypes.func,
    onSelectStartDate: PropTypes.func,
    onSelectOffset: PropTypes.func,
    startMaxDate: PropTypes.object,
    startMinDate: PropTypes.object
};

DateRangeFields.defaultProps = {
    endMaxDate: null,
    includeOffset: true,
    labelEndDate: 'Select an End Date:',
    labelOffset: 'Select a Time Zone Offset:',
    labelStartDate: 'Select a Start Date:',
    startMaxDate: null,
    startMinDate: null
};

export default DateRangeFields;



// WEBPACK FOOTER //
// ./src/Fuse/components/DateRangeFields.js